import { render, staticRenderFns } from "./SkillCard.vue?vue&type=template&id=6a18df21&"
import script from "./SkillCard.vue?vue&type=script&lang=ts&"
export * from "./SkillCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports